import { AfterViewInit, Component, ElementRef, Input, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { TableroInformativo } from '../../interfaces/tablero.interface';

@Component({
  selector: 'app-tablero-informativo',
  templateUrl: './tablero-informativo.component.html',
  styleUrl: './tablero-informativo.component.scss'
})
export class TableroInformativoComponent implements AfterViewInit, OnDestroy {
  @ViewChildren('rowBoard', { read: ElementRef }) rowBoard!: QueryList<ElementRef>;
  @Input() dataIndicators: TableroInformativo[][] = []
  private resizeObserver!: ResizeObserver;

  ngAfterViewInit(): void {
    const lastRow = this.rowBoard.last.nativeElement;

    this.resizeObserver = new ResizeObserver(entries => {
      if (entries[0].target === lastRow) {
        const parentWidth = (entries[0].target.parentNode as HTMLElement).clientWidth
        const children = [...lastRow.children];

        children.forEach(col => col.classList.remove('last-row'));

        let totalWidth = 0;
        let current: HTMLElement | null = children.at(-1);

        while (current) {
          const width = Math.trunc(current.getBoundingClientRect().width);
          totalWidth += width;

          if (totalWidth > parentWidth) break;

          current.classList.add('last-row')
          current = current.previousElementSibling as HTMLElement;
        }
      }
    });

    this.resizeObserver.observe(lastRow);
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  formatNumber(value: number): string {
    if (value == null) return '';

    const hasDecimals = value % 1 !== 0;
    const format = hasDecimals ? '1.0-2' : '1.0-0';
    return new Intl.NumberFormat('es-CO', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(value);
  }
}
